import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    redirect: 'dashboard',
    component: DashboardLayout,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        meta: {
          requiresAuth: true,
          breadcrumbTitle: 'Home'
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ '../views/Dashboard.vue')
      },
      {
        path: '/profile',
        name: 'profile',
        meta: {
          requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/UserProfile.vue')
      },
      {
        path: '/motorbikes',
        meta: {
          requiresAuth: true,
          breadcrumbTitle: 'Motorbikes'
        },
        component: () => import(/* webpackChunkName: "demo" */ '../views/Layout/Content.vue'),
        children: [
          {
            path: '',
            meta: {
              requiresAuth: true
            },
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Motorbikes.vue')
          },
          {
            path: 'new',
            name: 'newMotorbike',
            meta: {
              requiresAuth: true,
              breadcrumbTitle: 'New'
            },
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/MotorbikeNew.vue')
          },
          {
            path: ':id',
            meta: {
              requiresAuth: true
            },
            component: () => import(/* webpackChunkName: "demo" */ '../views/Layout/Content.vue'),
            children: [
              {
                path: '',
                name: 'motorbike',
                meta: {
                  requiresAuth: true
                },
                component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Motorbike.vue')
              },
              {
                path: 'charts',
                name: 'motorbikeCharts',
                meta: {
                  requiresAuth: true,
                  breadcrumbTitle: 'Charts'
                },
                component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/MotorbikeCharts.vue')
              }
            ]
          }
        ]
      },
      {
        path: '/trips',
        meta: {
          breadcrumbTitle: 'Trips',
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "demo" */ '../views/Layout/Content.vue'),
        children: [
          {
            path: '/',
            name: 'trips',
            meta: {
              breadcrumbTitle: 'Trips',
              requiresAuth: true
            },
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Trips.vue')
          },
          {
            path: 'new',
            name: 'newTrip',
            meta: {
              requiresAuth: true,
              breadcrumbTitle: 'New'
            },
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/TripNew.vue')
          },
          {
            path: ':id',
            name: 'trip',
            meta: {
              requiresAuth: true
            },
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Trip.vue')
          }
        ]
      },
      {
        path: '/map',
        name: 'map',
        meta: {
          requiresAuth: true,
          breadcrumbTitle: 'Map'
        },
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Map.vue')
      },
      {
        path: '/gps-devices',
        meta: {
          requiresAuth: true,
          breadcrumbTitle: 'GPS Devices'
        },
        component: () => import(/* webpackChunkName: "demo" */ '../views/Layout/Content.vue'),
        children: [
          {
            path: '/',
            name: 'gpsdevices',
            meta: {
              breadcrumbTitle: 'GPS Devices',
              requiresAuth: true
            },
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/GPSDevices.vue')
          },
          {
            path: 'new',
            name: 'newGpsDevice',
            meta: {
              requiresAuth: true,
              breadcrumbTitle: 'New'
            },
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/GPSDeviceNew.vue')
          },
          {
            path: ':id',
            name: 'gpsdevice',
            meta: {
              requiresAuth: true
            },
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/GPSDevice.vue')
          }
        ]
      },
      {
        path: '/checkpoints',
        meta: {
          requiresAuth: true,
          breadcrumbTitle: 'Checkpoints'
        },
        component: () => import(/* webpackChunkName: "demo" */ '../views/Layout/Content.vue'),
        children: [
          {
            path: '/',
            name: 'checkpoints',
            meta: {
              requiresAuth: true,
              breadcrumbTitle: 'Checkpoints'
            },
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Checkpoints.vue')
          },
          {
            path: 'new',
            name: 'newCheckpoint',
            meta: {
              requiresAuth: true,
              breadcrumbTitle: 'New'
            },
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/CheckpointNew.vue')
          },
          {
            path: ':id',
            name: 'checkpoint',
            meta: {
              requiresAuth: true
            },
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Checkpoint.vue')
          }
        ]
      },
      {
        path: '/maintenance',
        meta: {
          requiresAuth: true,
          breadcrumbTitle: 'Maintenance'
        },
        component: () => import(/* webpackChunkName: "demo" */ '../views/Layout/Content.vue'),
        children: [
          {
            path: '/',
            name: 'maintenances',
            meta: {
              requiresAuth: true,
              breadcrumbTitle: 'Maintenance'
            },
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Maintenances.vue')
          },
          {
            path: 'new',
            name: 'newMaintenance',
            meta: {
              requiresAuth: true,
              breadcrumbTitle: 'New'
            },
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/MaintenanceNew.vue')
          },
          {
            path: ':id',
            name: 'maintenance',
            meta: {
              requiresAuth: true
            },
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Maintenance.vue')
          }
        ]
      },
    ]
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Login.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Register.vue')
      },
      { path: '*', component: NotFound }
    ]
  }
];

export default routes;
